/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import ShardsVue from 'shards-vue';
import axios from 'axios';
//import moment from 'moment';
import VueAxios from 'vue-axios';
//import VueSelect from 'vue-cool-select'; 
//import DatePicker from 'vuejs-datepicker'; 
import Buefy from 'buefy'
//import Vue2Filters from 'vue2-filters'; 
//import vueNumeralFilterInstaller from 'vue-numeral-filter'; 
import VueGallery from 'vue-gallery'

import Vuelidate from 'vuelidate'; 
import VueLazyload from 'vue-lazyload';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
//import '@/assets/scss/date-range.scss';
import 'buefy/dist/buefy.css';
import '@/scss/shards-dashboards.scss';

// Core
import App from './App.vue';
import router from './router';
import env from './env.vue';
import store from './store';

// Layouts
import Default from '@/layouts/Default.vue';
import LoginDefault from '@/layouts/LoginDefault.vue';
import AttendanceDefault from '@/layouts/AttendanceDefault.vue';

ShardsVue.install(Vue);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/prayer.admin/img/loading.svg",
  loading: "/prayer.admin/img/loading.svg",
  attempt: 3
})
Vue.component('default-layout', Default);
Vue.component('login-layout', LoginDefault);
Vue.component('attendance-layout', AttendanceDefault);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
//Vue.prototype.moment = moment;
Vue.use(Vuex);
//Vue.use(DatePicker);
Vue.use(Vuelidate);
//Vue.use(VueLazyload);
Vue.component('VGallery', VueGallery)
Vue.use(Buefy, {defaultIconPack:'fas'});
//Vue.use(VueSelect,{theme:'bootstrap'});
/*
var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false
  },
  number: {
    format:'0',
    thousandsSeparator: ',',
    decimalSeparator: '.',
  },
  currency: {
    symbol: '',
    decimalDigits: 0,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false
  },
  pluralize: {
    includeNumber: false
  },
  ordinal: {
    includeNumber: false
  }
}
Vue.use(Vue2Filters,Vue2FiltersConfig);

Vue.filter('toNumber', function (value) {
    if (typeof value === "number") {
        return value;
    }
    return value.toString().replace(/,/g,'');
});
*/
store.commit('retry',0);
var server=env.server,
daxios=axios.create({
    baseURL: server+'/',
    timeout: 30000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    transformResponse: [function (data) {
       // Do whatever you want to transform the data
//       console.log( 'transform response', data );
       return data;
    }],
});
daxios.interceptors.request.use(function(config) {
  var token = store.state.token;
  config.retry= 5;
  config.retryDelay=10000;
  if ( token != null ) {    
    config.headers.Authorization = 'Bearer '+token;
  }
  return config;
}, function(err) {
  return Promise.reject(err);
});

daxios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return Promise.reject(err);

//    console.log( 'retry',store.state.retry,err );
    // Set the variable for keeping track of the retry count
    store.commit('retry', store.state.retry || 0 );

    // Check if we've maxed out the total number of retries
    if(store.state.retry >= config.retry) {
        // Reject with the error
//        theapp.$children[0].$children[0].$children[0].show_error('Connection Error...');
        if (!window.navigator.onLine)
          theapp.$children[0].$children[0].show_error('Connection error');
        return Promise.reject(err);
    }
//    console.log( 'retry',store.state.retry,err );
    // Increase the retry count
    store.commit('retry', store.state.retry+1);

    const backOffDelay = config.retryDelay
        ? ( (1/2) * (Math.pow(2, store.state.retry) - 1) ) * 1000
        : 1;

    // Create new promise to handle exponential backoff
    const backoff = new Promise((resolve) => {
        setTimeout(() => {
            if ( err.message.toString().match( /40[1-4]/ ) ){
                alert("Session expired,\nPlease re-login to continue" )
                  store.commit('token','');
                  self.location='/prayer.admin/';
                  return;
//                refreshToken().then( ()=>resolve() );
            } else if( err.message.toString().match( /409/ ) ){
                resolve();
//                theapp.$children[0].$children[0].$children[0].logout();            
            } else {
                resolve();
            }
        },  backOffDelay);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
            return daxios(config);
    });
});

//Sheet JS
var SheetJSFT = [
	"xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
].map(function(x) { return "." + x; }).join(",");

var SJSTemplate = [
	'<div style="padding-top:0.8em;padding-left:0.7em;">',
		'<input type="file" multiple="false" id="sheetjs-input" accept="' + SheetJSFT + '" @change="onchange" />',
		'<br/>',
//		'<button type="button" id="export-table" style="visibility:hidden" @click="onexport">Export to XLSX</button>',
		'<br/>',
		'<div id="out-table"></div>',
	'</div>'
].join("");

var HtmlPreview = Vue.component('html-preview', {
	template: SJSTemplate,
    props:{
        donations: Array,
        errors: Array,
    },

    mounted(){
        console.log(this.donations);
    },

	methods: {
		onchange: function(evt) {
			var file;
			var files = evt.target.files;

			if (!files || files.length == 0) return;

			file = files[0];

			var reader = new FileReader();
            var dthis=this;
			reader.onload = function (e) {
				// pre-process data
				var binary = "";
				var bytes = new Uint8Array(e.target.result);
				var length = bytes.byteLength;
				for (var i = 0; i < length; i++) {
					binary += String.fromCharCode(bytes[i]);
				}

				/* read workbook */
                var XLSX = window.XLSX;
				var wb = XLSX.read(binary, {type: 'binary'});

				/* grab first sheet */
                let arr=[];
				var wsname = wb.SheetNames[0];
				var ws = wb.Sheets[wsname];
                var list=XLSX.utils.sheet_to_json(ws, {header:1});
                if ( wb.SheetNames.length>1){
                  arr.push( { title:"Worksheet error", name:"Tidak boleh lebih dari 1"} );
                }
                if ( list[0].length<5){
                  arr.push( { title:"Jumlah kolom error", name:"harus ada minimal 5 kolom"} );
                }
                    /*
                let err=0;
                for ( var idx=1; idx<list.length; idx++ ){
                    if ( list[idx].length<8 ) {
                        err=1;
                        break;
                    }
                    for ( var idxb=0; idxb<list[idx].length; idxb++){
                        if ( list[idx][idxb]==undefined){
                            err=1;
                            break;
                        }
                    }
                }
                if ( err )
                  arr.push( { title:"Data error", name:"Kolom tdk boleh ada yg kosong"} );
                    */
                dthis.$emit('update:errors',arr);
                arr=[];
                for ( var idx=1; idx<list.length; idx++ ){
                    //if ( list[idx].length!=8 ) {
                        //continue;
                    //}
                    if ( list[idx].length==0 || list[idx][1]=='') continue;
                    for ( var j=2;j<=7;j++)
                      if (list[idx][j]==undefined)list[idx][j]='';

                    arr.push({
                        transdate : list[idx][0].toString().trim(),
                        name: list[idx][1].toString().replace(/\\|'|"/g,''),
                        amount: list[idx][2]+"",
                        say: list[idx][3]+"",
                        prefix: list[idx][4]+"",
                    });
                }
                dthis.$emit('update:donations',arr);
                console.log(arr);
                
				/* generate HTML */
//				var HTML = XLSX.utils.sheet_to_html(ws);

				/* update table */
//				document.getElementById('out-table').innerHTML = HTML;
				/* show export button */
//				document.getElementById('export-table').style.visibility = "visible";
			};
			reader.readAsArrayBuffer(file);
		},
		onexport: function(evt) {
			/* generate workbook object from table */
            var XLSX = window.XLSX;
            console.log(evt);
			var wb = XLSX.utils.table_to_book(document.getElementById('out-table'));
			/* generate file and force a download*/
			XLSX.writeFile(wb, "sheetjs.xlsx");
		}
	}
});

Vue.use(VueAxios,daxios)
let theapp=new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
